module.exports = __webpack_public_path__ + "img/mountain_left.c585a443.svg";